import {ComponentRef} from '@angular/core';
import {Router} from '@angular/router';
import {Observable, timer} from 'rxjs';
// import scrollIntoView from 'scroll-into-view-if-needed';

import {MixinConstructor} from './mixin.define';
import {LINK_POPUP_DELAY, LIST_TYPE, RESULT_LINKPOPUP, SearchParam} from '../defines/client.const';
import {DynamicComponentService} from '../services/dynamic-component/dynamic-component.service';
import {LayoutMgrService} from "../services/layout-mgr/layout-mgr.service";
import {WordHanjaPopupComponent} from "../components/word-hanja-popup/word-hanja-popup.component";


type WordHanjaMixinType = {
  router: Router,
  dynamicSvc: DynamicComponentService,
  lm: LayoutMgrService,
};

/**
 * 단일 mixin을 사용하는 경우의 정의.
 */
export const wordHanjaMixin = WordHanjaMixinFunction(
  class Parent {
    constructor(
      public router: Router,
      public dynamicSvc: DynamicComponentService,
      public lm: LayoutMgrService,
    ) {
    }
  }
);

export function WordHanjaMixinFunction<BaseType extends MixinConstructor<WordHanjaMixinType>>(BaseClass: BaseType) {
  return class extends BaseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    private elRefWordHanjaPopup: ComponentRef<WordHanjaPopupComponent> | null = null;


    /**
     *
     * @param hanja - 팝업창에 열 한자
     * @param container - 링크 팝업창을 열 기준이 되는 요소
     * @param disp - 링크에 표시되는 문자열
     */
    public OpenWordHanja(hanja: string, disp: string | null = null): Observable<RESULT_LINKPOPUP> {
      // TODO: disp 는 사용하지 않는다. 추후에 제거해야 한다.
      console.log('WordHanjaMixin::OpenWordHanja() : hanja=', hanja);

      return new Observable<RESULT_LINKPOPUP>(observer => {
        if (!this.lm.vcRef) {
          observer.error('WordHanjaMixinFunction::OpenWordHanja() vcRef is null');
          return;
        }

        try {
          this.elRefWordHanjaPopup = this.dynamicSvc.createComponent(WordHanjaPopupComponent, this.lm.vcRef);
        } catch (err) {
          console.error('WordHanjaMixin::OpenWordHanja() : Failed to create popup', err);
          observer.error(err);
          return;
        }

        /******************************************************************************************
         * 팝업창이 닫힐 때 발생하는 이벤트 이벤트 처리.
         */
        this.elRefWordHanjaPopup.instance.close.subscribe((hanja: string | null) => {
          console.log('WordHanjaMixin::OpenWordHanja() : hanja=', hanja);

          observer.next(RESULT_LINKPOPUP.POPUP_CLOSE);

          if (hanja) {
            const queryParams: SearchParam = {hanja, l: LIST_TYPE.SERVER};
            this.router.navigate(['/saseung'], {queryParams}).then();
          }

          observer.complete();
          this.closeWordHanjaPopup();
        });


        /******************************************************************************************
         * 화면에 초기화 된 후 (ngAfterViewInit()) 발생하는 이벤트 처리.
         */
        this.elRefWordHanjaPopup.instance.viewInit.subscribe((nativeEl: HTMLElement) => {

          // 팝업창이 열리는 애니메이션이 끝난 뒤에 스크롤 해야 정확한 위치로 스크롤이 된다.
          timer(LINK_POPUP_DELAY).subscribe(() => {
            console.log('WordHanjaMixin::OpenWordHanja() : viewInit=', nativeEl);

            // scrollIntoView(nativeEl, {
            //   behavior: 'smooth',
            //   block: 'end',
            //   scrollMode: 'if-needed',
            // });
          });
        });

        /******************************************************************************************
         * 팝업창에 표시할 정보 설정.
         */
        this.elRefWordHanjaPopup.instance.hanja = hanja;
        this.elRefWordHanjaPopup.changeDetectorRef.detectChanges();
      });
    }

    private closeWordHanjaPopup(): void {
      if (this.elRefWordHanjaPopup) {
        this.elRefWordHanjaPopup.destroy();
        this.elRefWordHanjaPopup = null;
      }
    }

  };
}
